module.exports = __webpack_public_path__ + "media/Video 76.2f976e70.mp4";